module.exports = __webpack_public_path__ + "img/guaranteeSate_09.11b2612e.png";